import React from 'react'
import {
  Table, TableBody, TableCell, TableHead, TableRow, IconButton, Paper, TableContainer,
} from '@material-ui/core'
import { Delete, AssignmentReturn } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
import { labelAnoBase } from 'pages/titulos-lbc/titulos-lbc.helpers'

const fmt = (n, lng) => Number(n || 0).toLocaleString(lng === 'pt-BR' ? 'pt-BR' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const r2 = (n) => Math.round(Number(n || 0) * 100) / 100
const saldoDevolvivel = (r) => r2(Number(r.quantidadeTotal) - (r.alocacoes || []).reduce((s, a) => s + Number(a.quantidade || 0), 0))

const Lista = ({ resgates = [], onExcluir, onDevolver, podeEditar = true }) => {
  const { t, i18n } = useTranslation()
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('resgatesLbc.codigoTitulo')}</TableCell>
            <TableCell>{t('resgatesLbc.destinataria')}</TableCell>
            <TableCell>{t('resgatesLbc.ecorregiao')}</TableCell>
            <TableCell>{t('resgatesLbc.anoBase')}</TableCell>
            <TableCell align="right">{t('resgatesLbc.quantidade')}</TableCell>
            {podeEditar && <TableCell align="right">{t('resgatesLbc.acoes')}</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {resgates.map((r) => (
            <TableRow key={r.id}>
              <TableCell>{r.titulo?.codigo || `#${r.tituloLbcId}`}</TableCell>
              <TableCell>{r.empresaDestinataria?.nome || '-'}</TableCell>
              <TableCell>{r.ecorregiao?.nome || '-'}</TableCell>
              <TableCell>{labelAnoBase(r.anoBase)}</TableCell>
              <TableCell align="right">{fmt(r.quantidadeTotal, i18n.language)}</TableCell>
              {podeEditar && (
                <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>
                  <IconButton
                    size="small" title={t('resgatesLbc.devolverSaldo')}
                    disabled={!(saldoDevolvivel(r) > 0)} onClick={() => onDevolver(r)}
                  >
                    <AssignmentReturn fontSize="small" />
                  </IconButton>
                  <IconButton size="small" title={t('resgatesLbc.excluir')} onClick={() => onExcluir(r)}><Delete fontSize="small" /></IconButton>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default Lista
